import styled from "styled-components";

export const StyledHorizontalStepperListContainer = styled.div``;
export const StyledHorizontalStepperList = styled.ol`
  display: flex;
  padding: 0;
`;
